module.exports = __webpack_public_path__ + "static/media/nl-NL.c58a1ef6.md";